module.exports = __webpack_public_path__ + "img/062.2ba4e0ad.jpeg";